import resetForm from './resetForm';
import toggleModalProduct from './toggleModalProduct';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(toggleModalProduct(false));
};
